var _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 156,
    viewBox: "0 0 229 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.214,
    cy: 151.436,
    rx: 80,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4395,
    cy: 52.46,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.3345,
    cy: 4.56494,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.113,
    cy: 126.565,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.15137,
    y1: 86.1299,
    x2: 4.15137,
    y2: 92.1299,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.21387,
    y1: 89.3799,
    x2: 1.21387,
    y2: 89.3799,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.401,
    y1: 27.8799,
    x2: 209.401,
    y2: 33.8799,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 212.464,
    y1: 31.1299,
    x2: 206.464,
    y2: 31.1299,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 150.167,
    y1: 11.4927,
    x2: 150.167,
    y2: 17.4927,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.229,
    y1: 14.7427,
    x2: 147.229,
    y2: 14.7427,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.698 59.1028C67.2044 59.1028 67.6148 58.6917 67.6148 58.1847C67.6148 57.6776 67.2044 57.2666 66.698 57.2666C66.1917 57.2666 65.7812 57.6776 65.7812 58.1847C65.7812 58.6917 66.1917 59.1028 66.698 59.1028Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1773 59.1027C70.6836 59.1027 71.0941 58.6917 71.0941 58.1846C71.0941 57.6776 70.6836 57.2665 70.1773 57.2665C69.671 57.2665 69.2605 57.6776 69.2605 58.1846C69.2605 58.6917 69.671 59.1027 70.1773 59.1027Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6568 59.1028C74.1631 59.1028 74.5736 58.6917 74.5736 58.1847C74.5736 57.6776 74.1631 57.2666 73.6568 57.2666C73.1504 57.2666 72.74 57.6776 72.74 58.1847C72.74 58.6917 73.1504 59.1028 73.6568 59.1028Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.566 60.3416H64.7944C64.6155 60.3416 64.4705 60.4867 64.4705 60.6656C64.4705 60.8445 64.6155 60.9896 64.7944 60.9896H180.566C180.745 60.9896 180.89 60.8445 180.89 60.6656C180.89 60.4867 180.745 60.3416 180.566 60.3416Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.123 46.46H49.017C47.9861 46.46 47.1504 47.2957 47.1504 48.3266V130.432C47.1504 131.463 47.9861 132.299 49.017 132.299H179.123C180.154 132.299 180.99 131.463 180.99 130.432V48.3266C180.99 47.2957 180.154 46.46 179.123 46.46Z",
    fill: "#DDE4EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.066 46.5156H48.9596C47.9287 46.5156 47.093 47.3513 47.093 48.3822V53.8021H180.933V48.3822C180.933 47.3513 180.097 46.5156 179.066 46.5156Z",
    fill: "#8792A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.406 57.9251H52.9542C51.9234 57.9251 51.0876 58.7608 51.0876 59.7917V88.7811C51.0876 89.812 51.9234 90.6477 52.9542 90.6477H175.406C176.437 90.6477 177.273 89.812 177.273 88.7811V59.7917C177.273 58.7608 176.437 57.9251 175.406 57.9251Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.772 65.164H64.8059C63.5808 65.164 62.5876 65.8463 62.5876 66.688C62.5876 67.5297 63.5808 68.212 64.8059 68.212H159.772C160.997 68.212 161.99 67.5297 161.99 66.688C161.99 65.8463 160.997 65.164 159.772 65.164Z",
    fill: "#DDE4EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8111 72.784H64.8059C63.5808 72.784 62.5876 73.4663 62.5876 74.308C62.5876 75.1497 63.5808 75.832 64.8059 75.832H95.8111C97.0362 75.832 98.0293 75.1497 98.0293 74.308C98.0293 73.4663 97.0362 72.784 95.8111 72.784Z",
    fill: "#DDE4EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.976 80.4037H64.8059C63.5808 80.4037 62.5876 81.0861 62.5876 81.9277C62.5876 82.7694 63.5808 83.4517 64.8059 83.4517H130.976C132.201 83.4517 133.194 82.7694 133.194 81.9277C133.194 81.0861 132.201 80.4037 130.976 80.4037Z",
    fill: "#DDE4EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.486 94.7706H53.0341C52.0032 94.7706 51.1675 95.6063 51.1675 96.6372V125.627C51.1675 126.657 52.0032 127.493 53.0341 127.493H175.486C176.517 127.493 177.353 126.657 177.353 125.627V96.6372C177.353 95.6063 176.517 94.7706 175.486 94.7706Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.14 102.01H66.6085C65.4277 102.01 64.4705 102.692 64.4705 103.534C64.4705 104.375 65.4277 105.058 66.6085 105.058H158.14C159.321 105.058 160.278 104.375 160.278 103.534C160.278 102.692 159.321 102.01 158.14 102.01Z",
    fill: "#DDE4EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4922 109.629H66.6085C65.4277 109.629 64.4705 110.312 64.4705 111.153C64.4705 111.995 65.4277 112.677 66.6085 112.677H96.4922C97.673 112.677 98.6303 111.995 98.6303 111.153C98.6303 110.312 97.673 109.629 96.4922 109.629Z",
    fill: "#DDE4EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 117.249H66.6085C65.4277 117.249 64.4705 117.932 64.4705 118.773C64.4705 119.615 65.4277 120.297 66.6085 120.297H130.385C131.566 120.297 132.523 119.615 132.523 118.773C132.523 117.932 131.566 117.249 130.385 117.249Z",
    fill: "#DDE4EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6076 51.1003C56.127 51.1003 56.5482 50.6786 56.5482 50.1584C56.5482 49.6382 56.127 49.2165 55.6076 49.2165C55.0881 49.2165 54.667 49.6382 54.667 50.1584C54.667 50.6786 55.0881 51.1003 55.6076 51.1003Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1781 51.1003C59.6976 51.1003 60.1187 50.6786 60.1187 50.1584C60.1187 49.6382 59.6976 49.2165 59.1781 49.2165C58.6587 49.2165 58.2375 49.6382 58.2375 50.1584C58.2375 50.6786 58.6587 51.1003 59.1781 51.1003Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0282 51.1003C52.5477 51.1003 52.9688 50.6786 52.9688 50.1584C52.9688 49.6382 52.5477 49.2165 52.0282 49.2165C51.5088 49.2165 51.0876 49.6382 51.0876 50.1584C51.0876 50.6786 51.5088 51.1003 52.0282 51.1003Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5876,
    y: 39.6003,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3018 39.6003C48.9849 39.6003 46.7201 40.2874 44.7937 41.5745C42.8674 42.8617 41.3659 44.6912 40.4793 46.8317C39.5927 48.9721 39.3607 51.3274 39.8127 53.5998C40.2647 55.8721 41.3804 57.9593 43.0186 59.5976C44.6569 61.2358 46.7441 62.3515 49.0164 62.8035C51.2888 63.2555 53.6441 63.0235 55.7846 62.1369C57.925 61.2503 59.7545 59.7488 61.0417 57.8225C62.3288 55.8961 63.0159 53.6313 63.0159 51.3144C63.0068 48.2105 61.7697 45.2362 59.5748 43.0414C57.38 40.8465 54.4057 39.6094 51.3018 39.6003Z",
    fill: "#56D187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7303 45.3145H50.8732C50.5576 45.3145 50.3018 45.6726 50.3018 46.1145V56.5145C50.3018 56.9563 50.5576 57.3145 50.8732 57.3145H51.7303C52.0459 57.3145 52.3018 56.9563 52.3018 56.5145V46.1145C52.3018 45.6726 52.0459 45.3145 51.7303 45.3145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3018 51.743V50.8859C57.3018 50.5703 56.9551 50.3145 56.5276 50.3145H46.076C45.6484 50.3145 45.3018 50.5703 45.3018 50.8859V51.743C45.3018 52.0586 45.6484 52.3145 46.076 52.3145H56.5276C56.9551 52.3145 57.3018 52.0586 57.3018 51.743Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.214 151.436) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5876,
    y: 39.6003,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperation);
export default __webpack_public_path__ + "static/media/operation.562e8d4ab4c56d29062a3bd5d67c419c.svg";
export { ForwardRef as ReactComponent };